module.exports = {
    expired_1: "リンクの有効期限が切れています",
    limit_time: "期間限定オファー ",
    participate: "今すぐレビューイベントに参加して、限定報酬を獲得しましょう！",
    exclusive: "限定",
    reward: "報酬",
    token: "トークン",
    vip: "日間VIP",
    after_completing: "レビューとスクリーンショット確認を完了後、受け取れます",
    step_1: "<strong style='color: #000000'>下のボタンをクリック</strong>してアプリストアにアクセスし、<strong style='color: #000000'>5つ星のレビューを投稿してください。</strong>",
    step_2: "レビュー完了後、レビュー内容の<strong style='color: #000000'>スクリーンショットを撮影</strong>してください。",
    step_3: "下記に<strong style='color: #000000'>スクリーンショットをアップロード</strong>し、アプリ内IDを提出して報酬を受け取ってください。",
    click_to: "1. クリックして ",
    upload: "2. レビューのスクリーンショットをアップロード",
    app_store: "App Store",
    google_play: "Google Play",
    go_to: "へ移動 ",
    example: "スクリーンショットの例",
    upload_screenshot: "スクリーンショットをアップロード",
    claim: "報酬を受け取る",
    verification_inprogress: "アップロードありがとうございます。スクリーンショットをできるだけ早く確認中です。しばらくお待ちください。",
    verification_success: "おめでとうございます！ <br/><br/> 報酬の受け取りに成功しました。報酬は<strong>24時間以内</strong>にアカウントに付与されます。今しばらくお待ちください。 <br/><br/> ご質問がある場合は、カスタマーサポートまでお気軽にお問い合わせください。",
    verification_failed: "レビューのスクリーンショットは以下の条件を満たす必要があります： <br/><br/> <div style='margin-left: 6px'> 1.評価は5つ星で、内容は肯定的であること。 <br/><br/> 2.レビューは<strong>Apple App StoreまたはGoogle Play Store</strong>で行われていること。 <br/><br/> 3.スクリーンショットにはレビュー内容が完全に表示されていること、<strong>アバター、ユーザー名、レビューテキストを含む</strong>。 <strong></div>",
    reupload: "再アップロード"
}